const MAP: Record<string, string> = {
  'auth/invalid-credential': 'Those credentials were not accepted.',
  'auth/user-not-found': 'Those credentials were not accepted.',
  'auth/wrong-password': 'Those credentials were not accepted.',
  'auth/invalid-email': 'Please enter a valid email address.',
  'auth/email-already-in-use': 'This email already has a place at the mandap. Sign in instead.',
  'auth/weak-password': 'Choose a password of at least 8 characters.',
  'auth/popup-closed-by-user': 'The sign-in window was closed.',
  'auth/popup-blocked': 'The browser blocked the sign-in window. Allow popups and try again.',
  'auth/operation-not-allowed': 'That sign-in method is not enabled on this Firebase project yet.',
  'auth/too-many-requests': 'Too many attempts. Please wait a little and try again.',
  'auth/network-request-failed': 'Network error. Check the connection and retry.',
};

export function authMessage(err: unknown): string {
  if (typeof err === 'object' && err && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (MAP[code]) return MAP[code];
  }
  if (err instanceof Error && err.message) return err.message;
  return 'Something went wrong. Please try again.';
}
